module.exports = __webpack_public_path__ + "img/person.a2c8d9f6.png";